import { Col, Modal, Row } from "react-bootstrap";
import { MCCheckbox, MCInput, MCLabel } from "../../../MainComponents";
import { useState } from "react";
import { useEffect } from "react";
import { enqueueSnackbar } from "notistack";
import { createUser } from "../../../../apis/apiUsers";
import { useTranslation } from "react-i18next";
import { CheckIconCircle } from "../../../Icon";
import {
  Autocomplete,
  Box,
  Chip,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { EGInput } from "../../../MainComponents/Input/EGInput";
import { EGCheckbox } from "../../../MainComponents/Checkbox/EGCheckbox";
import { updateUserRoles } from "../../../../apis/apiUsers";
import { useParams } from "react-router-dom";
import { EGButton } from "../../../MainComponents/Button/EGButton/EGButton";

const RolesList = ({ items, userId, values, onChange = () => {} }) => {
  const [selecteds, setSelecteds] = useState(values);
  const [t] = useTranslation("users");

  // {
  //   "email": "test.ethicsglobal+9@gmail.com",
  //   "password": "T3st&ng#",
  //   "first_name": "Template",
  //   "last_name": "Prueba T1",
  //   "username": "templete_1"
  // }

  useEffect(() => {
    onChange(selecteds);
  }, [selecteds]);

  function onSelected(value, checked) {
    if (checked === true) {
      const itExist = selecteds.includes(value);
      if (itExist) return;
      setSelecteds([...selecteds, value]);
    }
    if (checked === false) {
      const filtredSelecteds = selecteds.filter((item) => item != value);
      setSelecteds(filtredSelecteds);
    }
  }

  function toggleSelectAll() {
    if (selecteds.length === items.length) {
      setSelecteds([]); // Si todos están seleccionados, los deselecciona
    } else {
      setSelecteds(items.map((item) => item.value)); // Si no todos están seleccionados, los selecciona todos
    }
  }

  return (
    <>
      <ul className="ps-0">
        <a onClick={toggleSelectAll}>
          <small>
            {selecteds.length === items.length
              ? t("Users.deselect_all")
              : t("Users.select_all")}
          </small>
        </a>
        {items.map((item, idx) => (
          <li
            key={item.value}
            style={{ listStyle: "none" }}
            className="d-flex mb-2"
          >
            <MCCheckbox
              id={`${userId}-${idx}-${item.value}`}
              className="me-2"
              onChange={(e) => onSelected(item.value, e.target.checked)}
              checked={selecteds.includes(item.value)}
            />
            <label
              className="pointer"
              htmlFor={`${userId}-${idx}-${item.value}`}
            >
              {item.label}
            </label>
          </li>
        ))}
      </ul>
    </>
  );
};

const ErrorMessages = ({ messages = [] }) => {
  return messages.map((item, idx) => (
    <small key={idx} style={{ color: "red", display: "block" }}>
      {item}
    </small>
  ));
};

export const ModalAssignUser = ({
  user,
  handleChange,
  setIsLoading,
  registred = true,
  target,
  show,
  onHide,
}) => {
  const [t] = useTranslation("users");
  const { id } = useParams();

  const initUserForm = {
    username: [],
    email: [],
    password: [],
  };

  const [username, setUsername] = useState(user?.name ?? "");
  const [isRegistred] = useState(registred);
  const [details, setDetails] = useState("");
  const [rolesInvestigation, setRolesInvestigation] = useState(
    user?.assign_details?.rolesInvestigation || []
  );
  const [rolesResolution, setRolesResolution] = useState(
    user?.assign_details?.rolesResolution || []
  );
  const [focused, setFocused] = useState(false);
  const [detailsVisible, setDetailsVisible] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [validationErrors, setValidationErrors] = useState(initUserForm);
  const [tryToCreate, setTryToCreate] = useState(false);

  useEffect(() => {
    const assignDetails = user?.assign_details;
    setDetails(assignDetails?.details || "");
    setRolesInvestigation(assignDetails?.rolesInvestigation || []);
    setRolesResolution(assignDetails?.rolesResolution || []);
  }, [user, show]);

  const handleInvestigationRolesChange = (event, newValue) => {
    const selectedValues = newValue.map((option) => option.value);
    setRolesInvestigation(selectedValues);
  };

  const handleResolutionRolesChange = (event, newValue) => {
    const selectedValues = newValue.map((option) => option.value);
    setRolesResolution(selectedValues);
  };

  async function handleSubmitExternal() {
    setValidationErrors(initUserForm);
    setTryToCreate(true);
    try {
      const data = await createUser({
        username,
        first_name: username,
        email,
        password,
      });
      handleChange(
        {
          id: data.data.data.id,
          email: data.data.data.id,
          first_name: username,
        },
        () => {}, // setIsLoading
        "external", // target
        rolesInvestigation,
        rolesResolution,
        details
      );
      setUsername("");
      setEmail("");
      setPassword("");
      setRolesInvestigation([]);
      setRolesResolution([]);
      onHide();
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    }
  }

  async function handleUpdate() {
    setIsLoading(true);
    try {
      if (user?.id) {
        const reportId = parseInt(id, 10);
        if (isNaN(reportId)) {
          throw new Error(t("User.invalid_report_id"));
        }

        const dataToSend = {
          reportId,
          userId: user.id,
          rolesInvestigation,
          rolesResolution,
          details,
        };
        const response = await updateUserRoles(dataToSend);

        handleChange(
          user,
          setIsLoading,
          "update",
          rolesInvestigation,
          rolesResolution,
          details,
          response
        );
        onHide();
        setUsername("");
        setEmail("");
        setPassword("");
        setRolesInvestigation([]);
        setRolesResolution([]);
      }
    } catch (error) {
      enqueueSnackbar(error.message, {
        variant: "error",
        preventDuplicate: true,
        autoHideDuration: 3000,
      });
    } finally {
      setIsLoading(false);
    }
  }

  function handleAssign() {
    handleChange(
      user,
      setIsLoading,
      "inactive",
      rolesInvestigation,
      rolesResolution,
      details
    );
    onHide();
    setUsername("");
    setEmail("");
    setPassword("");
    setRolesInvestigation([]);
    setRolesResolution([]);
  }

  function handleUnlink() {
    handleChange(user, setIsLoading, "active");
    onHide();
    setUsername("");
    setEmail("");
    setPassword("");
    setRolesInvestigation([]);
    setRolesResolution([]);
  }

  function cleanAll() {
    onHide();
    setValidationErrors(initUserForm);
    setUsername("");
    setEmail("");
    setPassword("");
    setRolesInvestigation([]);
    setRolesResolution([]);
  }

  const investigationRoles = [
    {
      label: t("User.investigation_responsable"),
      value: "investigation_responsable",
    },
    {
      label: t("User.investigation_plan"),
      value: "investigation_plan",
    },
    {
      label: t("User.investigation_resources"),
      value: "investigation_resources",
    },
    {
      label: t("User.interview_design"),
      value: "interview_design",
    },
    {
      label: t("User.interview_executor"),
      value: "interview_executor",
    },
    {
      label: t("User.interview_witness"),
      value: "interview_witness",
    },
    {
      label: t("User.interview_help"),
      value: "interview_help",
    },
    {
      label: t("User.translator"),
      value: "translator",
    },
    {
      label: t("User.data_entry_operator"),
      value: "data_entry_operator",
    },
    {
      label: t("User.evidence_facilitator"),
      value: "evidence_facilitator",
    },
    {
      label: t("User.evidence_custody"),
      value: "evidence_custody",
    },
    {
      label: t("User.evidence_analysis"),
      value: "evidence_analysis",
    },
    {
      label: t("User.investigation_advisor"),
      value: "investigation_advisor",
    },
    {
      label: t("User.investigation_report"),
      value: "investigation_report",
    },
    {
      label: t("User.investigation_approve"),
      value: "investigation_approve",
    },
    {
      label: t("User.investigation_other"),
      value: "investigation_other",
    },
  ];

  const resolutionRoles = [
    {
      label: t("User.resolution_responsable"),
      value: "resolution_responsable",
    },
    {
      label: t("User.sanctions"),
      value: "sanctions",
    },
    {
      label: t("User.corrective_actions"),
      value: "corrective_actions",
    },
    {
      label: t("User.resolution_advisor"),
      value: "resolution_advisor",
    },
    {
      label: t("User.resolution_report"),
      value: "resolution_report",
    },
    {
      label: t("User.resolution_approve"),
      value: "resolution_approve",
    },
    {
      label: t("User.resolution_other"),
      value: "resolution_other",
    },
  ];

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Row>
        <Col md={8} className="flex-grow-1">
          {isRegistred ? (
            <>
              {/* <h4>Usuario asignado: </h4> */}
              <h4>{t("User.assigned_user_one")}</h4>

              <MCInput
                value={user?.name}
                onChange={(e) => setUsername(e.target.value)}
                disabled
              />
            </>
          ) : (
            <>
              {/* <h4>Nombre de usuario: </h4> */}
              <h4>{t("User.user_name")}</h4>

              <MCInput
                value={username}
                isValid={
                  !tryToCreate
                    ? true
                    : validationErrors.username.length === 0
                    ? true
                    : false
                }
                onChange={(e) => setUsername(e.target.value)}
              />
              {tryToCreate && validationErrors.username.length > 0 && (
                <ErrorMessages messages={validationErrors.username} />
              )}
              <h4>{t("User.email")}</h4>
              <MCInput
                value={email}
                isValid={
                  !tryToCreate
                    ? true
                    : validationErrors.email.length === 0
                    ? true
                    : false
                }
                onChange={(e) => setEmail(e.target.value)}
              />
              {tryToCreate && validationErrors.email.length > 0 && (
                <ErrorMessages messages={validationErrors.email} />
              )}
              <h4>{t("User.password")} </h4>
              <MCInput
                value={password}
                isValid={
                  !tryToCreate
                    ? true
                    : validationErrors.password.length === 0
                    ? true
                    : false
                }
                onChange={(e) => setPassword(e.target.value)}
              />
              {tryToCreate && validationErrors.password.length > 0 && (
                <ErrorMessages messages={validationErrors.password} />
              )}
            </>
          )}
        </Col>
        <Col md={4} className="d-block d-lg-flex pb-2">
          <div
            className={`d-flex align-items-center align-items-xl-end me-2 ${
              !isRegistred ? "disabled-filter" : ""
            }`}
          >
            <MCCheckbox
              className="me-2 mt-0"
              checked={isRegistred}
              disabled={!isRegistred}
            />
            <MCLabel text={t("User.registered_user")} />
          </div>
          <div
            className={`d-flex align-items-center align-items-xl-end ${
              isRegistred ? "disabled-filter" : ""
            }`}
          >
            <MCCheckbox
              className="me-2 mt-0"
              checked={!isRegistred}
              disabled={isRegistred}
            />
            <MCLabel text={t("User.external_user")} />
          </div>
        </Col>
      </Row>

      <hr className="my-4" />

      {/* <Row>
        <Col>
          <Autocomplete
            multiple
            id="investigation-roles-autocomplete"
            options={investigationRoles}
            disableCloseOnSelect
            getOptionLabel={(option) => option.label}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            value={investigationRoles.filter((option) =>
              rolesInvestigation.includes(option.value)
            )}
            onChange={handleInvestigationRolesChange}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li {...optionProps}>
                  <EGCheckbox
                    icon={<CheckIconCircle />}
                    checkedIcon={<CheckIconCircle />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    color="primary"
                  />
                  {option.label}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("User.investigation_roles")}
                variant="outlined"
              />
            )}
            renderTags={(tagValue, getTagProps) => (
              <Box
                sx={{
                  maxHeight: { xs: "15vh", md: "20vh" },
                  minHeight: "30px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  mr: 1,
                  my: 0.33,
                  gap: 0.3,
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  pointerEvents: "none",
                }}
              >
                {(focused ? tagValue : tagValue.slice(0, 3)).map(
                  (option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.value}
                      sx={{
                        fontSize: { xs: 7, md: 10 },
                        px: { xs: 0, md: 0.5 },
                        mr: 0.5,
                        mb: 0.5,
                        pointerEvents: "auto",
                      }}
                      label={
                        <Typography variant="body1" mx={{ xs: 0.5, md: 1 }}>
                          {option.label}
                        </Typography>
                      }
                      size="small"
                      onDelete={() => {
                        const newRoles = rolesInvestigation.filter(
                          (val) => val !== option.value
                        );
                        setRolesInvestigation(newRoles);
                      }}
                    />
                  )
                )}
                {!focused && tagValue.length > 3 && (
                  <Typography variant="caption" mx={{ ml: 1 }}>
                    +{tagValue.length - 3} {t("User.more")}
                  </Typography>
                )}
              </Box>
            )}
          />
        </Col>
        <Col>
          <Autocomplete
            multiple
            id="resolution-roles-autocomplete"
            options={resolutionRoles}
            disableCloseOnSelect
            getOptionLabel={(option) => option.label}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            value={resolutionRoles.filter((option) =>
              rolesResolution.includes(option.value)
            )}
            onChange={handleResolutionRolesChange}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li {...optionProps}>
                  <EGCheckbox
                    icon={<CheckIconCircle />}
                    checkedIcon={<CheckIconCircle />}
                    style={{ marginRight: 8 }}
                    checked={selected}
                    color="primary"
                  />
                  {option.label}
                </li>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("User.resolution_roles")}
                variant="outlined"
              />
            )}
            renderTags={(tagValue, getTagProps) => (
              <Box
                sx={{
                  maxHeight: { xs: "15vh", md: "20vh" },
                  minHeight: "30px",
                  overflowY: "auto",
                  overflowX: "hidden",
                  mr: 1,
                  my: 0.33,
                  gap: 0.3,
                  display: "flex",
                  flexDirection: "row",
                  flexWrap: "wrap",
                  pointerEvents: "none",
                }}
              >
                {(focused ? tagValue : tagValue.slice(0, 3)).map(
                  (option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      key={option.value}
                      sx={{
                        fontSize: { xs: 7, md: 10 },
                        px: { xs: 0, md: 0.5 },
                        mr: 0.5,
                        mb: 0.5,
                        pointerEvents: "auto",
                      }}
                      label={
                        <Typography variant="body1" mx={{ xs: 0.5, md: 1 }}>
                          {option.label}
                        </Typography>
                      }
                      size="small"
                      onDelete={() => {
                        const newRoles = rolesResolution.filter(
                          (val) => val !== option.value
                        );
                        setRolesResolution(newRoles);
                        localStorage.setItem(
                          "resolutionRoles",
                          JSON.stringify(newRoles)
                        );
                      }}
                    />
                  )
                )}
                {!focused && tagValue.length > 3 && (
                  <Typography variant="caption" mx={{ ml: 1 }}>
                    +{tagValue.length - 3} {t("User.more")}
                  </Typography>
                )}
              </Box>
            )}
          />
        </Col>
      </Row>

      <Row id="details-section">
        {details ? (
          !detailsVisible ? (
            <div className="mb-2">
              <label className={`${t("User.details")}: fw-bold p-1`}>
                {t("User.details")}:
              </label>
              <div className="border p-2 rounded bg-light">{details}</div>
              <Link
                onClick={() => setDetailsVisible(true)}
                underline="hover"
                className="p-1"
              >
                {t("User.edit_details")}
              </Link>
            </div>
          ) : (
            <EGInput
              label={`${t("User.details")}:`}
              multiline
              rows={3}
              value={details}
              onChange={(e) => setDetails(e.target.value)}
            />
          )
        ) : !detailsVisible ? (
          <Link onClick={() => setDetailsVisible(true)} underline="hover">
            {`+ ${t("User.more_details")}`}
          </Link>
        ) : (
          <EGInput
            label={`${t("User.details")}:`}
            multiline
            rows={3}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
        )}
      </Row> */}

      <Row className="mt-2">
        <Col className="d-flex justify-content-between align-items-start flex-wrap">
          {target === "active" ? (
            <EGButton
              color="error"
              label={t("User.unlink_user")}
              onClick={handleUnlink}
            />
          ) : (
            <EGButton
              color="primary"
              label={t("User.assign_user")}
              className="mt-2 mt-lg-0"
              onClick={isRegistred ? handleAssign : handleSubmitExternal}
            />
          )}

          <div className="d-flex gap-2 flex-wrap">
            {target === "active" && (
              <EGButton
                color="primary"
                label={t("User.update_user")}
                className="mt-2 mt-lg-0"
                onClick={handleUpdate}
              />
            )}
            <EGButton
              color="primary"
              variant="outlined"
              label={t("User.cancel")}
              className="mt-2 mt-lg-0"
              onClick={cleanAll}
            />
          </div>
        </Col>
      </Row>
    </Modal>
  );
};
